export const ToggleAuditOpen = () => {
  return {
    type: "TOGGLE_AUDIT_OPEN",
  };
};
export default ToggleAuditOpen;
